import React from 'react'
import Icon from './icon'
import Header from './header'
import Switch  from './switch'
import Lane from './lane'
import './feature.css'

/**
 * FeatureFactory
 */
const FeatureFactory = ( FField, config = {} ) => {

  return class Feature extends React.Component {

    componentDidMount() {
      if (this.props.default && this.props.onChange) this.props.onChange(this.props.id, this.props.default)
    }

    state = {
      edit: false,
      value: this.props.default,
      valid: true,
      custom: false
    }

    toggleEdit = () => {
      this.setState({ edit: !this.state.edit })
    }

    onValueChange = (id, value) => {
      this.setState({ value, edit: false })
      if (this.props.onChange) this.props.onChange(id, value)
    }

    onClear = () => {
      this.onValueChange(this.props.id, null)
    }

    toggleCustom = () => {
      const nextCustom = !this.state.custom;
      this.setState({ custom: nextCustom })
      if (this.props.onCustom) this.props.onCustom(this.props.id, nextCustom)
    }

    check = () => {
      let valid = true
      if (this.props.filterBy) {
        //const filter = this.filter()
        //valid = this.props.options.some( option => (option.filter === filter && option.value === this.state.value) )
      }
      if (this.state.valid !== valid) this.setState({ valid })
    }

    renderField = () => {
      let actions = []
      if (config.toggler === false) {
        actions.push(<FField {...this.props} value={this.state.value} onChange={this.onValueChange} />)
      } else {
        actions.push(<Icon icon="keyboard_arrow_left" clickable className="toggler" action={this.toggleEdit}/>)
        actions.push(<Icon icon="close" clickable className="small" action={this.onClear}/>)
        actions.push(<FField {...this.props} value={this.state.value} onChange={this.onValueChange} onCustom={this.toggleCustom} clear />)
      }
      return actions
    }

    renderValue = () => {
      this.check()
      let actions = []
      const value = this.state.valid ? this.state.value : <Icon icon="warning" className="small"/>
      const option = this.props.options ? this.props.options.find( option => option.value === value) : null
      const label = option ? option.label : value
      if (config.toggler === false) {
        actions.push(<FField {...this.props} value={this.state.value} onChange={this.onValueChange} />)
      } else {
        actions.push(<Icon icon="keyboard_arrow_right" clickable action={this.toggleEdit} className="toggler"/>)
        actions.push(<div className="value">{label}</div>)
      }
      return actions
    }

    renderCustom = () => {
      let actions = []
      actions.push(<Icon icon="keyboard_arrow_right" clickable action={this.toggleEdit} className="toggler"/>)
      actions.push(<Icon icon="close" className="small" clickable action={this.toggleCustom} />)
      actions.push(<TextInput {...this.props} value={this.state.value} onChange={this.onValueChange} />)
      return actions
    }

    render() {
      const icon = { icon: this.props.mandatory ? 'star' : this.props.icon ? this.props.icon : '' }
      const field = this.state.edit ?
                      this.state.custom ? this.renderCustom() : this.renderField()
                        : this.renderValue()
      return (
        <div className="feature" >
          <Header icon={icon} title={this.props.label}>
            {field}
          </Header>
        </div>
      )
    }
  }
}

/**
 * Feature Set
 */
class FeatureSet extends React.Component {

  state = {
    active : this.props.active || false
  }

  toggleActive = () => {
    if (this.props.onChange)
      this.props.onChange(!this.state.active)
    this.setState({ active: !this.state.active })
  }

  renderSwitcher = () => {
    return this.props.optional ? <Switch value={this.state.active} onChange={this.toggleActive}/> : ''
  }

  renderFeatures = () => {
    if (this.props.optional === undefined) {
      return this.props.children
    } else if (this.props.optional && this.state.active) {
      return this.props.children
    } else {
      return ''
    }
  }

  render() {
    const active = this.props.optional && !this.state.active ? 'hidden': ''
    return (
      <div className={`feature-set ${active} ${this.props.className}`}>
        <header>{this.props.title}<div style={{ flex: 1 }} />{this.props.toolbar}{this.renderSwitcher()}</header>
        <main>{this.renderFeatures()}</main>
      </div>
    )
  }
}

/**
 * TextInput
 */
const TextInput = ({ id, value = '', onChange }) => {

  const onEnter = (event) => {
    if (event.keyCode === 13) {
      onChange(id, this.field.value)
    }
  }

  const onBlur = () => {
    if (this.field.value != value )
      onChange(id, this.field.value)
  }

  return (
    <div className="feature-number">
      <input type="text" placeholder={value} focused onKeyUp={onEnter} autofocus
        ref={ field => {
          this.field = field
          if (field) {
            field.value = value
            field.focus()
          }
        }}
        onBlur={onBlur}
      />
    </div>
  )
}

/**
 * NumericInput
 */
const NumericInput = ({ id, value = 0, onChange }) => {

  const onEnter = (event) => {
    if (event.keyCode === 13) {
      onChange(id, this.field.value)
    }
  }

  const onBlur = () => {
    if (this.field.value != value )
      onChange(id, this.field.value)
  }

  return (
    <div className="feature-number">
      <input type="number" placeholder={value} focused onKeyUp={onEnter} autofocus
        ref={ field => {
          this.field = field
          if (field) {
            field.value = value
            field.focus()
          }
        }}
        onBlur={onBlur}
      />
    </div>
  )
}



const Number = FeatureFactory(NumericInput, {})
const Selector = FeatureFactory(Lane, {})
const Switcher = FeatureFactory(Switch, { toggler: false })
export default FeatureFactory
export { FeatureSet, Switcher, Selector, Number }



// WEBPACK FOOTER //
// ./src/lib/components/feature.js